export default __webpack_public_path__ + "static/media/login.12bdd669.png";